<div class="wrapper__headerComponent container my-5">
    <div class="container-example-linea-avance-govco mx-0 my-5">
      <div class="linea-avance-govco ih-linea-avance-govco m-0 p-0" id="lineaAvance3">
        <div class="mb-4">
          <div class="progress" style="width: 100% !important;">
            <progress class="progress-bar" value="15" max="100">
            </progress>
          </div>
          <div class="items-header-linea-avance-govco">
            <div class="header-linea-avance-govco active-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance1" percentage="8"
                onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(1)">
                <span>1</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][0] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance2"
                percentage="17" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(2)">
                <span>2</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][1] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance3"
                percentage="27" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(3)">
                <span>3</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][2] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance4"
                percentage="37" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(4)">
                <span>4</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][3] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance5"
                percentage="48" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(5)">
                <span>5</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][4] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance6"
                percentage="58" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(6)">
                <span>6</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][5] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance7"
                percentage="69" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(7)">
                <span>7</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][6] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance8"
                percentage="78" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(8)">
                <span>8</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][7] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance9"
                percentage="86" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(9)">
                <span>9</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][8] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance10"
                percentage="90" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(10)">
                <span>10</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][12] }}
              </span>
            </div>
            <div class="header-linea-avance-govco">
              <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance11"
                percentage="100" onClick="clickHorizontalAdvanceLine(event)" (click)="anterior(11)">
                <span>11</span>
              </button>
              <span class="title-linea-avance-govco">
                {{ vjiText['reorganizacion-ordinaria-insolvencia']['titulos'][13] }}
              </span>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance1" class="body-linea-avance-govco active-linea-avance-govco"
          data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección inicial -->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][0]"
                [fields]="vjiSucursalIdentificacionDeudor"
                (changedControl)="onSubmitSucursalIdentificacionDeudor($event)" [idEntidad]="entidadId"
                [withSubmitButton]="false">
              </app-form>
              <!-- // ARCHIVO
                // Certificado de Existencia y Representación Legal
                // Documento mediante el cuál el máximo órgano competente autoriza al representante legal, -->
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formIdentificacionDeudor.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance2" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Información de profesionales asociados al deudor -->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][2]"
                [fields]="vjiSucursalInformacionProfesionales"
                (changedControl)="onSubmitSucursalInformacionProfesionales($event)" [idEntidad]="entidadId"
                [withSubmitButton]="false">
              </app-form>
              <!-- // ARCHIVO
              /**
              * Poder al abogado para realizar la solicitud -> DEPENDE DE SI SELECCIONA APODERADO */
              // SECCION Memoria explicativa de las causas de insolvencia
              /* ARCHIVO
              * Memoria explicativa de las causas de insolvencia
              */
              ]; -->
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formInformacionProfesionales.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance3" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Supuestos de admisibilidad-->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][3]"
                [fields]="vjiSucursalSupuestosAdmisibilidad"
                (changedControl)="onSubmitSucursalSupuestosAdmisibilidad($event)" [idEntidad]="entidadId"
                [withSubmitButton]="false">
              </app-form>
              <!-- // ARCHIVOS
              /**
              * Certificación que acredite la cesación de pagos -> Depende de certificadoDesarrolloActividad opcion 1
              * Anexo de la certificación de cesación de pagos -> Depende de certificadoDesarrolloActividad opcion 1
              * Certificación que acredite la incapacidad de pago -> Depende de certificadoDesarrolloActividad opcion 2
              */ -->
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formSupuestosAdmisibilidad.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance4" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Relación de Pasivos (Artículo 32, Ley 1429 de 2010)-->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][4]"
                [fields]="vjiSucursalRelacionPasivos" (changedControl)="onSubmitSucursalRelacionPasivos($event)"
                [idEntidad]="entidadId" [withSubmitButton]="false">
              </app-form>
              <!-- // Archivos
              /**
              * Certificación de tener o no pasivos por retenciones obligatorias con el fisco
              * Plan para la atención de pasivos por retenciones obligatorias con el fisco -> Depende de que seleccione si
              */
              // ARCHIVOS
              /**
                * Certificación de tener o no tener pasivos por descuentos efectuados a trabajadores
                * Plan para la atención de pasivos por descuentos efectuados a trabajadores
                */
                // ARCHIVOS
                /**
                * Certificación de tener o no tener pasivos por aportes al sistema de seguridad social
                * Plan para la atención de pasivos al sistema de seguridad social
                */ -->
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formRelacionPasivos.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance5" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Información financiera con corte al último día calendario del mes anterior-->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][5]"
                [fields]="vjiSucursalInformacionFinancieraMes"
                (changedControl)="onSubmitSucursalInformacionFinancieraMes($event)" [idEntidad]="entidadId"
                [withSubmitButton]="false">
              </app-form>
              <!--
              // ARCHIVOS
              /**
              * Estados financieros del mes anterior (ESF, ER, EFE, ORI, ECP)
              * Notas y certificación a los estados financieros del mes anterior
              */
                -->
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formInformacionFinancieraMes.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance6" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Información financiera con corte al último año anterior-->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][6]"
                [fields]="vjiSucursalInformacionFinancieraAnio"
                (changedControl)="onSubmitSucursalInformacionFinancieraAnio($event)" [idEntidad]="entidadId"
                [withSubmitButton]="false">
              </app-form>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formInformacionFinancieraAnio.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance7" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Conjunto completo de estados financieros comparativos-->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][7]"
                [fields]="vjiSucursalEstadosFinancieros" (changedControl)="onSubmitSucursalEstadosFinancieros($event)"
                [idEntidad]="entidadId" [withSubmitButton]="false">
              </app-form>
              <!--
              //ARCHIVOS
              /**
              * SELECCIONA NO
              * Estados financieros del último año (2023)
              * Notas y certificación a los estados financieros del último año (2023)
              * Dictamen del revisor fiscal del último año (2023)(si aplica)
              * Estados financieros del penúltimo año (2022)
              * Notas y certificación a los estados financieros del penúltimo año (2022)
              * Dictamen del revisor fiscal del penúltimo año (2022) (si aplica)
              * Estados financieros del antepenúltimo año (2021)
              * Notas a estados financieros del antepenúltimo año (2021)
              * Dictamen del revisor fiscal del antepenúltimo año (2021) (si aplica)
              */
        -->

              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formEstadosFinancieros.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--
            // SECCION Inventario de activos y pasivos con corte al último día del mes anterior
            // ARCHIVOS
            /**
            * Inventario de activos del mes anterior
            * Inventario de pasivos del mes anterior
            */ -->
        <div id="itemlineaAvance8" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance9" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Otros documentos requeridos-->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][9]"
                [fields]="vjiSucursalOtrosDocumentos" (changedControl)="onSubmitSucursalOtrosDocumentos($event)"
                [idEntidad]="entidadId" [withSubmitButton]="false">
              </app-form>
              <!-- // ARCHIVOS
              /**
              * Certificación de llevar contabilidad regular
              * Documento de la composición accionaria
                      // Archivos
              // Selecciona si informacionRemitida
              // Certificación de no encontrarse en causal de disolución
              // Selecciona no informacionRemitida
              // Certificación causal de disolución
                  // ARCHIVOS
              // SELECCIONA SI pasivosPensionales
              /**
              * Certificación del monto de las obligaciones causadas por cálculo actuarial
              * Documento que acredita el cálculo actuarial
              * Aprobación del cálculo actuarial
              * Certificación de encontrarse al día en mesadas pensionales, bonos y títulos pensionales
              */
                    // Archivos
              /**
              * Certificación en la que se relacione los terceros a los cuales el deudor es (avalista, garante o codeudor de terceros)
              *
              */
              */
            -->
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3">
                <h4 class="wrapper__form__content__subtitle">
                  {{ vjiText['validacion-judicial-insolvencia']['subtitulos'][0] }},
                  {{ vjiText['validacion-judicial-insolvencia']['subtitulos'][1] }},
                  {{ vjiText['validacion-judicial-insolvencia']['subtitulos'][2] }} y
                  {{ vjiText['validacion-judicial-insolvencia']['subtitulos'][3] }}
                </h4>
              </div>
              <!--
                  /**SECCION Plan de negocios, Flujo de caja proyectado Y Proyectos de calificación y graduación de créditos y derechos de voto
            *
            * Certificación depende si seleccionan si, el resto no dependen de ninguno
            * Plan de negocios de reorganización
            * Flujo de caja proyectado
            * Proyecto de calificación y graduación de créditos y proyecto de determinación de derechos de voto
            */
            -->
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formOtrosDocumentos.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance10" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Reporte de bienes sujetos a garantías mobiliarias-->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][13]"
                [fields]="vjiSucursalReporteBienesMobiliarios"
                (changedControl)="onSubmitSucursalReporteBienesMobiliarios($event)" [idEntidad]="entidadId"
                [withSubmitButton]="false">
              </app-form>
              <!--
              // Archivos
              // SELECCIONA SI garantiaInmobiliaria
              /**
              * Certificación de bienes sujetos a garantías mobiliarias, adicionalmente, indicar cuáles de los mismos son necesarios para la actividad del deudor
              * Avalúo de los bienes
              * Certificación que relacione las obligaciones que surgen de la adquisición del bien sujeto a garantía
              */-->
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonal(event)"
                  [disabled]="formReporteBienesMobiliarios.invalid">
                  {{ vjiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div id="itemlineaAvance11" class="body-linea-avance-govco" data-la-parent="#lineaAvance3">
          <div class="contents-linea-avance-govco">
            <div class="contents-example-linea-avance-govco">
              <!-- Sección Documentos Adicionales-->
              <app-form [title]="vjiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][14]"
                [fields]="vjiSucursalDocumentosAdicionales"
                (changedControl)="onSubmitSucursalDocumentosAdicionales($event)" [idEntidad]="entidadId"
                [withSubmitButton]="false">
              </app-form>
              <div class="mt-3">
                <div class="card">
                  <div class="card-header">
                    <h5 class="card-title">
                      {{ vjiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                    </h5>
                  </div>
                  <div class="card-body form-group">
                    <app-cargue-archivos-tramite [archivosPreCargados]="[]" [idTipoTramite]="tipoTramite"
                      [idTramite]="idTramiteSsoVji" [btnEnviar]="false" [enviar]="enviarDocumentos"
                      [enviarEntidad]="enviarEntidad" (guardo)="subirArchivo($event)"
                      (archivosCargados)="validarArchivosCargados($event)">
                    </app-cargue-archivos-tramite>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-md-5 mt-3">
                <button type="button" class="btn-govco fill-before-btn-govco me-3" style="width: 165px; height: 42px;"
                  onclick="nextItemAdvanceLineIHorizonalBack(event)">
                  {{ vjiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco me-3 btn-form" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(false)">
                  {{ vjiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button class="btn-govco fill-send-govco ms-2" style="width: 180px; height: 42px"
                  (click)="onSubmitFormulario(true)" [disabled]="getValidForms()">
                  {{ vjiText['botones-envio']['finalizar-enviar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
